/**
 * api.ts - the shape of every backend response, matching the backend's
 * Section 40.2 (ApiResponse envelope) and Section 39.1 (ErrorResponse).
 * Every feature's api/*.ts file imports these instead of redefining them.
 */
export interface ApiEnvelope<T> {
  success: boolean;
  message: string;
  data: T;
  requestId: string;
}

export interface PagedData<T> {
  content: T[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
}

export interface FieldError {
  field: string;
  message: string;
}

/** Normalized shape every thrown API error is converted into - see apiClient.ts's interceptor. */
export interface NormalizedApiError {
  message: string;
  errorCode: string;
  status: number;
  requestId: string;
  fieldErrors: FieldError[];
}

export function isNormalizedApiError(error: unknown): error is NormalizedApiError {
  return (
    typeof error === 'object' &&
    error !== null &&
    'errorCode' in error &&
    'status' in error &&
    'fieldErrors' in error
  );
}
